// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1XhRO","footer":"Form_footer__3fZL-"};